<div class="container-fluid cw-background manage-maintenance-provider manage-view">
  <mat-card class="mat-elevation-z8 my-3">
    <div class="text-left go-back d-block">
      <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
        <mat-icon matPreffix>arrow_back_ios</mat-icon>
        Go Back
      </button>
      <h6 class="card-title-page mb-4">Edit Maintenance Provider:</h6>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
        <app-dynamic-form
          *ngIf="questions"
          [questions]="questions"
          [disabled]="!isEdit"
          (formSubmit)="onSubmit($event)"
        >
        </app-dynamic-form>
        <button
          *ngIf="currentUser.hasRight(['admin']) && currentUser.isGlobal()"
          (click)="toggleManageConfig()"
          class="edit"
          color="primary"
          mat-icon-button
        >
          <mat-icon>create</mat-icon><span class="mat-h3"> Edit</span>
        </button>
      </div>
    </div>
    <div class="row d-flex delete-btn">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
        <button
          *ngIf="currentUser.hasRight(['admin']) && currentUser.isGlobal()"
          (click)="deleteConfigModal()"
          disableRipple
          mat-button
          class="delete"
        >
          <mat-icon matPreffix>delete</mat-icon>
          Delete Maintenance Provider
        </button>
      </div>
    </div>
    <div class="container-fluid cw-background">
      <div class="row">
        <div class="col-12">
          <mat-tab-group [@.disabled]="true">
            <mat-tab label="Partners">
              <app-data-table
                *ngIf="partnersTableConfig"
                [config]="partnersTableConfig"
                (getData)="getPartners($event)"
                (updateData)="partnersTableService.update($event)"
              ></app-data-table>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </mat-card>
</div>
